import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './bootstrap-5.3.0-alpha1-dist/css/bootstrap.css';
import './bootstrap-icons-1.10.3/bootstrap-icons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
